import React, {Component} from 'react';
import Helmet from 'react-helmet';
import {connect} from 'react-redux';
import * as clientActions from 'redux/modules/clients';

import * as productActions from 'redux/modules/products';
import * as ficheActions from 'redux/modules/fiches';
import * as ticketActions from 'redux/modules/tickets';
import * as supervisionActions from 'redux/modules/supervision';
import * as groupActions from 'redux/modules/groups';
import * as userActions from 'redux/modules/users';

import {isLoaded as areClientsLoaded, load as loadClients, loadCOMClients, loadCOMSupervisors} from 'redux/modules/clients';
import {isLoaded as areModulesLoaded, load as loadModules} from 'redux/modules/modules';
import {initializeWithKey} from 'redux-form';
import { ComClientForm, ComProductList } from 'components';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
var _ = require('underscore');

import {DropdownButton, MenuItem, Col, Row, Panel, OverlayTrigger, Tooltip, Button} from 'react-bootstrap';


import {ReloadButton} from 'components';

import moment from 'moment';


import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({store: {dispatch, getState}, params}) => {
    const promises = [];
      
      promises.push(dispatch(loadCOMSupervisors(params)));
      promises.push(dispatch(loadModules()));
    
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    clients: state.clients.comClients,
    editing: state.clients.editing,
    error: state.clients.error,
    loading: state.clients.loading,
    loading_coms : state.clients.loading_coms,
    sendCredentialsLoading: state.clients.sendCredentialsLoading,
    modules: state.modules.data,
    sending: state.clients.sending,
    editMode: state.clients.editMode,
    user: state.auth.user,
  }),
  {...clientActions, initializeWithKey })

export default class ComClientList extends Component {
  
  componentDidMount(){
  	this.props.dispatch(productActions.clearProducts());
  	this.props.dispatch(ficheActions.clearFiches());
  	this.props.dispatch(groupActions.clearGroups());
  	this.props.dispatch(userActions.clear());
  	this.props.dispatch(ticketActions.clearTickets());
  	this.props.dispatch(supervisionActions.unmount());
    this.props.dispatch(clientActions.resetComForm());  	
  }

  render() {
        
  	const {
  	  clients, error, editing, 
  	  loading, load, modules, 
  	  sendCredentialsLoading, sending, dispatch, 
  	  params, resetCredentials, loading_coms, 
  	  editMode, user, t
  	} = this.props;
  	  	  	  	
  	let refreshClassName = 'fa fa-refresh';
  	let refreshSCC = 'fa fa-refresh';

  	if (loading) {
      refreshClassName += ' fa-spin';
    }

    const styles = require('./Clients.scss');

  	var client_rows = [];
  	
  	for( var id in clients ) {
  		
    	var client = clients[id];
    	
    	client.expiry_date   = moment(client.expiry_date)
    	client.rappel1       = moment(client.rappel1)
    	client.rappel2       = moment(client.rappel2)
    	
    	var mods_names = client.modules.map((m)=>{
    		return m.name;
    	}).join(', ');

    	var mods_ids = client.modules.map((m)=>{
    		return m.id;
    	})
    	   	    	
    	const handleEdit = (client) => {
        const {editStart} = this.props; // eslint-disable-line no-shadow
        return () => editStart(String(client.id));
      };

      const handleDelete = (username) => {
        const {deleteClient} = this.props; // eslint-disable-line no-shadow
        return () => deleteClient(String(username));
      };
      

      const handleSendCredentials = (client) => {
        const {sendCOMCredentials} = this.props;
        return () => {          
          if( ! confirm(t('client.confirm_send_back_cred')) ) {
            return
          }
          
          client.expiry_date = client.expiry_date.format('DD/MM/YYYY')
        
          sendCOMCredentials(client).then( () => {
            setTimeout(()=>{ resetCredentials(client.id); }, 2000);
          }

        );          
      }};
    	
      var products = client.products || [];
      
      client.hyperUser.login = client.hyperUser.login.split('-')[0]
    	var form =(
    	  <div>
  	    	<ComClientForm formKey={String(client.id)} user={user}
  	    	  key={String(client.id)} action='update'
  	    	  initialValues={{id:client.cli_id, ...client, modules:mods_ids}} 
  	    	   client={client} products={products}
  	    	>
          </ComClientForm>
        </div>
      );


    	
    	var textSend = '';
	    	
    	try {
	    	if( sending[client.id].loading == true ) {
	      	refreshSCC += ' fa-spin';
	      	var disabled = true;
	    	} else {
	    		refreshSCC = 'fa fa-refresh';
	    		var disabled = false;
	    	}

	    	if( sending[client.id].loaded == true ) {

	    		refreshSCC += ' fa-thumbs-up';
	    		var sendStyleBtn = 'btn-success';
	    		//var textSend = 'Identifiants renvoyés';
	    	}

    	} catch(e) {
    		refreshSCC = 'fa fa-refresh';
    		var disabled = false;
    		var sendStyleBtn = '';

    		//var textSend = 'Renvoyer les identifiants';
    	}
    	
    	
    	var actionTD = 
    	  <td>
          <div style={{width:'100px'}}>
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
            <strong>{t('client.edit_client')}</strong>
            </Tooltip>}>
            <Button bsStyle='primary' bsSize="sm" onClick={handleEdit(client)}>
              <i className="fa fa-pencil"/>
            </Button>
          </OverlayTrigger>
          
          &nbsp;
          
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
            <strong>{t('users.send_credentials')}</strong>
            </Tooltip>}>
            <Button disabled={disabled} bsSize="sm" className={sendStyleBtn} 
              onClick={handleSendCredentials(client)}>
              <i className={refreshSCC}/> {textSend}
            </Button> 
          </OverlayTrigger>
          
        </div>
        {/*<ConsultMenu client={client.login} label={"Consultation"}/>*/}
      </td>
      
      var etat = '';
      var color = 'black'
        
      if ( client.hyperUser.validated == 0  ) {
        etat = t('client.validation_email_sent')
        color = 'blue'
      }
      else if ( client.hyperUser.validated == null ) {
        etat = t('client.validation_email_not_sent')
        color = 'orange'
      }
      else if ( client.hyperUser.validated == 1 ) {
        etat = t('client.client_validated_account')
        color = 'green'
      }

      if ( client.hyperUser.etat == 2  ) {
        etat = t('users.limite')
        color = 'red'
      }
      
      if ( client.hyperUser.etat == 3 ) {
        etat = t('main.deactivated')
        color = 'red'
      }
      
      
      const tooltip1 = (
        <Tooltip id="tooltip">
          <strong>{etat}</strong>
        </Tooltip>
      );
      
      etat = <OverlayTrigger placement="top" overlay={tooltip1}><i className="fa fa-circle" style={{"color":color}}/></OverlayTrigger>              
    	
    	var tds = [
  	    <td>{etat}</td>,
  	    actionTD, 
  	    <td>{client.hyperUser.login}-{client.cli_id}-sup</td>,
  	    <td>{client.expiry_date.format('DD/MM/YYYY HH:mm')}</td>,
        <td>{client.hyperUser.email}</td>,         
        <td>{client.hyperUser.telephone}</td>,   
        <td>{client.hyperUser.prenom}<br/>{client.hyperUser.nom}</td>,
        <td>{client.hyperUser.societe}</td>,
        <td>{mods_names}</td>,        
        <td>{client.products ? client.products.length : 0}</td>,                
      ]
      /*
      if(client.products && client.products.length > 0 ){
        tds.push(
        <td>
          {client.products.map((p)=>p.last_cyclical_row ? <div style={{width:'200px'}}>{p.identification_NUM_ASC} : {p.last_cyclical_row.call_reason}</div> :'')}
        </td>)
      
      }*/
    

    	var tr = (
    		<tr key={client.id}>    		
				  {tds}
				</tr>
    	);
    	
    	client_rows.push(tr)
    	
    	var content;

    	if( editing[client.id] == true ) {
    	  content = form;
    	  
    	  break
    	} else {
    	  
    	  if( clients ) {
          content = (
             
            <div className="table-responsive">
        	    <table className="table table-striped">
                <thead>
                <tr>
                  <th>{t('main.state')}</th>
                  <th>{t('main.actions')}</th>                  
                  <th>{t('main.username')}</th>
                  <th>{t('main.contract_duree')}</th>
                  <th>Email</th>
                  <th>{t('main.phone')}</th>
                  <th>{t('main.firstname')} & {t('main.lastname')}</th>
                  <th>{t('main.society')}</th>
                  <th>{t('main.modules')}</th>                  
                  <th>{t('main.nb_products')}</th>
                  
                  
                  {/* <th>Alertes</th>
                 
                  
                  <th>Rappel 1</th>
                  <th>Rappel 2</th>*/}
                </tr>
                </thead>
                <tbody>
                { client_rows }
                </tbody>
              </table>
            </div>
          )
          
    	 }
    	  
    	  
    	}
    		
    	
    }

    return (
      <div className={styles.clients + ' container'}>
        <h1>
          Clients &nbsp;
          {!editMode &&
            <ReloadButton module="clients" submit={()=>dispatch(loadCOMSupervisors(this.props.params))} loading={loading_coms}/>
          }
        </h1>
        <Helmet title="Clients"/>
        {content}
        {error &&
        	
        <Col md={3} >
        <div className="alert alert-danger" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {t('main.connection_error')}
        </div></Col>}
        
      </div>
    );
  }
}

